import React from 'react';

import {SignoffAdhoc} from 'app/components/general/GenericDocumentActionButtons/SignoffRequestModal/SignoffAdhoc';
import {SignoffTeams} from 'app/components/general/GenericDocumentActionButtons/SignoffRequestModal/SignoffTeams';
import TabbedModal from 'app/components/general/TabbedModal';
import {getContentType} from 'app/utils/content-type';
import {gt} from 'app/utils/i18n';

import type {BaseActionableDocumentType} from 'app/general/types';

type Props = {
  contentType: 'procedure' | 'policy' | 'proceduregroup';
  document: BaseActionableDocumentType;
  onClose: () => void;
  onSuccess: (doc?: BaseActionableDocumentType) => unknown;
  isOpen: boolean;
};

export function SignoffRequestModal({
  document,
  contentType,
  onClose,
  isOpen,
  onSuccess,
}: Props) {
  const ct = getContentType(contentType);

  return (
    <TabbedModal
      show={isOpen}
      onCancel={onClose}
      tabs={[
        {
          eventKey: 'main-tab',
          name: gt('By Team'),
          icon: ct.icon,
          content: (
            <SignoffTeams
              document={document}
              contentType={contentType}
              onClose={onClose}
              onSuccess={onSuccess}
            />
          ),
        },
        {
          eventKey: 'adhoc-tab',
          name: gt('By User'),
          icon: ct.icon,
          content: (
            <SignoffAdhoc
              document={document}
              contentType={contentType}
              onClose={onClose}
              onSuccess={onSuccess}
            />
          ),
        },
      ]}
    />
  );
}
